<template><a-list-item
        class="tower-card" :style="{ borderColor: color.primary }"
    >
        <a-list-item-meta>
            <div slot="description" class="tower-card-main"
                :style="{ background: `linear-gradient(90deg, transparent, ${ color.value + '1A' })` }"
            >
                <a :href="dashboardLink" target="_blank" class="mocking">
                    <a-row class="tower-card-header" type="flex">
                        <a-col>
                            <span class="author" title="作者">{{ tower.author }}</span>
                            <span v-if="tower.author2" title="复刻者">/{{ tower.author2 }}</span>
                        </a-col>
                        <a-col class="info-bar">
                            <span class="info-block info-block-people" title="游玩人数 / 通关人数">
                                <a-icon type="user" /><span>{{ tower.people }} / {{ tower.win }}</span>
                            </span>
                            <span class="info-block info-block-hot" title="热度 - 24小时内游玩量">
                                <a-icon type="fire" :theme="tower.hot > 99 ? 'filled' : 'outlined'"/>
                                <span>{{ tower.hot }}</span>
                            </span>
                        </a-col>
                    </a-row>
                    <a-row class="tower-content">
                        <a-col>
                            <p v-html="tower.text"></p>
                        </a-col>
                    </a-row>
                </a>
                <a-row class="stat-list">
                    <div class="chart" ref="chart"></div>
                </a-row>
                <a-row class="tag-list">
                    <a-col>
                        <a-tag color="red" v-if="intest">测试期</a-tag>
                        <a-tag v-for="tag of tags" :key="tag">{{ tag }}</a-tag>
                        <a-tag>{{ tower.floors }}层</a-tag>
                        <span class="comment-tag">
                            [<a :href="dashboardLink" target="_blank"><span :style="{ color:  color.primary }">{{ tower.comment }}</span>条评论</a>]
                        </span>
                    </a-col>
                </a-row>
            </div>
        </a-list-item-meta>
    </a-list-item>
</template>

<script>
import echarts from '../../../echartusage'
import { COLORS } from '../../../constant'
import axios from 'axios';

export default {
    props: {
        tower: Object,
    },
    computed: {
        color() {
            return COLORS[this.tower.color];
        },
        tags() {
            const tags = this.tower.tag.split("|");
            if (tags[tags.length-1] == "") tags.pop();
            return tags;
        },
        intest() {
            return Date.now() / 1000 - 172800 < this.tower.createTime;
        },
        dashboardLink() {
            return `/score.php?name=${ this.tower.name }&num=10`
        }
    },
    async mounted() {
        const { data } = await axios.get("/backend/tower/chart.php", {
            params: { tower: this.tower.name }
        });
        this.chart = echarts.init(this.$refs.chart);
        const option = {
            tooltip: {
                trigger: 'axis',
                position: (pt) => [pt[0], '10%'],
            },
            grid: {
                left: 40,
                right: 20,
                top: 20,
                bottom: 20
            },
            title: {
                left: 'center',
                text: '游戏人数统计',
            },
            toolbox: {
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.map((x) => x[0]),
            },
            yAxis: {
                type: 'value',
                boundaryGap: [0, '25%'],
            },
            dataZoom: [{
                type: 'inside',
                start: 0,
                end: 100
            }, {
                start: 0,
                end: 10,
                handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                handleSize: '80%',
                handleStyle: {
                    color: '#fff',
                    shadowBlur: 3,
                    shadowColor: 'rgba(0, 0, 0, 0.6)',
                    shadowOffsetX: 2,
                    shadowOffsetY: 2
                }
            }],
            series: [
                {
                    name: '当日游戏人数',
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    sampling: 'average',
                    itemStyle: {
                        normal: {
                            color: 'rgb(255, 70, 131)'
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(255, 158, 68)'
                            }, {
                                offset: 1,
                                color: 'rgb(255, 70, 131)'
                            }])
                        }
                    },
                    data: data.map((x) => parseInt(x[1]))
                }
            ]
        }
        this.chart.setOption(option);
    }
}
</script>

<style lang="less" scoped>
.tower-card.ant-list-item {
    width: fit-content;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    border-left: 10px solid;
    border-bottom: none;
}
.ant-list-item-meta-avatar {
    margin-right: 0;
}
.tower-card-header {
    padding-top: 3px;
}
.info-bar {
    margin-left: auto;
    padding-right: 8px;
    .info-block {
        font-size: 13px;
        padding-left: 10px;
        display: inline-block;
        text-align: right;
        span {
            display: inline-block;
        }
    }
    .info-block-people {
        min-width: 88px;
        span {
            min-width: 72px;
        }
    }
    .info-block-hot {
        color: #e33e33;
        min-width: 40px;
        span {
            min-width: 24px;
        }
    }
}
.ant-list-item-meta-content {
    min-height: 150px;
    padding-left: 16px;
    width: 800px;
    .tower-content {
        margin-top: auto;
        height: 24px;
        p {
            font-size: 13px;
            margin-bottom: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin: 0;
        }
    }
    .author {
        color: rgba(0, 0, 0, 0.85);
    }
    .author2 {
        color: #6e6e6e;
    }
}
.ant-row {
    margin-right: 5px;
}
.tower-card-main {
    min-height: 150px;
}
.mocking {
    color: inherit;
}
.tag-list {
    margin-top: 5px;
    margin-bottom: 5px;
    .ant-col {
        display: flex;
    }
    .comment-tag {
        margin-left: auto;
    }
    a {
        font-size: 13px;
        padding: 1px;
        color: inherit;
        span {
            font-weight: bold;
        }
    }
}
.chart {
    height: 100px;
}
</style>
